// hooks/useCidades.ts
import { useState, useEffect } from "react";
import { cidadeService } from "../services/cidadeService";
import { Cidade } from "../interfaces/Cidade";

export const useCidade = (fetch: boolean, estadoId?: number | undefined) => {
  const [isLoading, setIsLoading] = useState(true);
  const [cidades, setCidades] = useState<Cidade[]>([]);

  useEffect(() => {
    const fetchCidade = async () => {
      if (fetch) {
        setIsLoading(true);
        try {
          const data = await cidadeService(estadoId);
          if (data) {
            setCidades(data);
          } else {
            console.error("Dados não encontrados para o usuário");
          }
        } catch (error) {
          console.error("Erro ao buscar cidades:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchCidade();
  }, [estadoId, fetch]); // Dependência de estadoId e fetch para garantir que a chamada seja feita quando necessário

  return { isLoading, cidades };
};
